// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isCodePrincipleMet = (positions: any): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  positions.every((el: any) => el.met !== false);
